<md-dialog>
	<div md-dialog-header>
		<md-icon icon="untitled-ui/time/clock-snooze"></md-icon>
		Request A Leave Of Absence
	</div>

	<div class="dialog-content">
		<div class="left">
			<div>Need an extended break?</div>
			<div>
				In situations where unexpected circumstances require time off, you have the option to apply for a leave of absence for up to 180 days. Submit
				your request, and our team will carefully assess and approve it. Following the conclusion of your leave, you may resume your studies, or return
				earlier if you feel prepared to do so.
			</div>
		</div>

		<div class="right">
			<div>
				<div>Reason</div>
				<div class="form-field">
					<md-drop-down [options]="reasonOptions"></md-drop-down>
				</div>
			</div>

			<div>
				<div>Please Provide More Details</div>
				<div class="form-field details-textarea">
					<textarea
						md-form-input
						placeholder="e.g. Requesting a leave of absence due to a family matter that requires my extended presence. I plan to return and resume lessons as soon as this is resolved."
						rows="5"
					></textarea>
				</div>
			</div>

			<div>
				<div>Period</div>
				<div class="start-end">
					<input type="date" placeholder="YYYY-MM-DD" value="2024-09-27" md-form-input md-date-picker-input />
					<input type="date" placeholder="YYYY-MM-DD" value="2024-09-27" md-form-input md-date-picker-input />
				</div>
			</div>
		</div>
	</div>

	<div md-dialog-footer>
		<button md-button (click)="close()">Cancel</button>
		<button md-button-brand>Submit</button>
	</div>
</md-dialog>
